import React, { useCallback, memo } from 'react';
import Button from '@atlaskit/button';
import EditorFeedbackIcon from '@atlaskit/icon/glyph/editor/feedback';
import { useFeedbackCollector } from '@atlassian/jira-business-feedback-collector/src/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

const FEEDBACK_GROUP_ID = 'jsw-list-feedback';

const FeedbackButton = () => {
	const { formatMessage } = useIntl();
	const openFeedbackModal = useFeedbackCollector({ projectType: 'software' });

	const onClick = useCallback(() => {
		openFeedbackModal(FEEDBACK_GROUP_ID);
	}, [openFeedbackModal]);

	const content = (
		<Button
			iconBefore={<EditorFeedbackIcon label="" size="medium" />}
			appearance="subtle"
			onClick={onClick}
		>
			{formatMessage(messages.feedback)}
		</Button>
	);

	return content;
};

export default memo(FeedbackButton);
